import Popup from 'react-popup'
import './popup.scss'

/**
 * Open a confirm popup using react-popup
 * showing a message and a Cancel and Ok button.
 *
 * @param {Object} options
 * @property {string} title
 * @property {string} message
 * @property {string} [confirmText]
 * @property {string} [cancelText]
 * @property {string} [confirmClassName]
 * @property {string} [cancelClassName]
 * @property {function () : undefined} onConfirm
 * @property {function () : undefined} [onCancel]
 */
export function confirmPopup({
  title,
  message,
  confirmText,
  cancelText,
  confirmClassName,
  cancelClassName,
  onConfirm,
  onCancel
}) {
  const bringToFront = true

  Popup.create(
    {
      title: title || 'Confirm',
      content: message,
      className: 'confirm',
      buttons: {
        left: [],
        right: [
          {
            text: cancelText || 'Cancel',
            className: cancelClassName || 'cancel secondary',
            key: 'esc',
            action: () => {
              Popup.close()

              if (onCancel) {
                onCancel()
              }
            }
          },
          {
            text: confirmText || 'Ok',
            className: confirmClassName || 'ok',
            key: 'enter',
            action: () => {
              Popup.close()

              onConfirm()
            }
          }
        ]
      }
    },
    bringToFront
  )
}
